
const DashboardPage = () => {

  return (

      <div className="bg-gray-100 py-12 px-6">
        <h1 className="text-3xl font-bold mb-6 text-center">ダッシュボード</h1>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
        </div>
      </div>
  );
};

export default DashboardPage;